<template>
  <div>
    <TableFilters
      :filters="['warehouse']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`lowstockexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :headers="headers"
              :items="lowStockList"
              :single-expand="singleExpand"
              item-key="name"
              class="row-pointer"
              id="indextable7"
            >
              <template v-slot:item.product="{ item }" v-slot="{ errors }">{{
                item.product.name
              }}</template>
              <template v-slot:item.wareHouse="{ item }" v-slot="{ errors }">
                {{
                  WarehouseView == 'name'
                    ? item.wareHouse.name
                    : item.wareHouse.sortform
                }}</template
              >
              <template v-slot:item.batch="{ item }" v-slot="{ errors }">{{
                item.batch.batch
              }}</template>
              <template v-slot:item.unit="{ item }" v-slot="{ errors }">{{
                item.unit.name
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
    <!-- </v-card> -->
    <div class="d-flex justify-center align-center"></div>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import { mapState } from 'vuex';
import confirmation from '../shared/components/confirmation';

import _ from 'lodash';
export default {
  components: {
    TableFilters,
  },
  data() {
    return {
      hide: 'auto',
      singleExpand: false,
      errormsg: false,
      isLoading: true,
      warehouseerror: '',
      columns: [
        {
          text: 'No',
          value: 'no',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.no,
        },
        {
          text: 'Product',
          value: 'product',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.product.name,
        },
        {
          text: 'Warehouse',
          value: 'wareHouse',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.wareHouse.name,
        },
        {
          text: 'Unit',
          value: 'unit',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.unit.name,
        },
        {
          text: 'Batch',
          value: 'batch',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.batch.batch,
        },
        {
          text: 'Available Stock',
          value: 'available_stock',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.available_stock,
        },
        {
          text: 'Reorder Level',
          value: 'reorder_level',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.reorder_level,
        },
        {
          text: 'Damage',
          value: 'damage',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.damage,
        },
      ],
      lowStockList: [],
      filter: {
        warehouse: '',
      },
    };
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.warehouse) {
        this.errormsg = false;

        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
        var filter = this.filter;
        this.$store
          .dispatch('report/getLowStockReports', filter)
          .then((res) => {
            this.lowStockList = res.data.data;
            let i = 1;
            this.lowStockList.map((p) => {
              p.no = i;
              i++;
            });
            setTimeout(() => {
              callBack();
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.lowStockList);
              // Update Pdf To List_Title
              this.$store.commit('UPDATE_PDF_TITLE', 'Low Stocks');
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            }, 100);
          })
          .catch((err) => {
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);

            this.warehouseerror = err.data;
            this.isLoading = false;
            this.messages = err.data.title;
          });
      } else {
        this.$confirm('Please Select the Warehouse then Try?');
      }
    },

    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.lowStockList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.lowStockList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].product = Data[x].product.name;
          Data[x].wareHouse = Data[x].wareHouse.name;
          Data[x].batch = Data[x].batch.batch;
          Data[x].unit = Data[x].unit.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica');
        doc.text('Low Stock Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        const conditions = [{ key: 'warehousequery', label: 'Warehouse' }];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }

          return acc;
        }, 12); // Initial

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: 15,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-LowStockReport.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable7');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-LowStockReport.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  computed: {
    ...mapState(['filterDatas']),
    ...mapState(['WarehouseView']),

    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>

<style scoped>
.warehouse-red {
  color: red;
}
.report-button {
  font-size: 12px !important;
  color: white !important;
}

@media (min-width: 1264px) {
  .v-application .mx-lg-1 {
    margin-right: 30px !important;
    margin-left: 16px !important;
  }
  .v-application .px-lg-1 {
    padding-right: 4px !important;
    padding-left: 20px !important;
  }
}
</style>
